var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',[(_vm.type === `bar`)?_c('bar',{attrs:{"label":_vm.label,"is-small":_vm.isSmall}}):_c('spinner',{attrs:{"label":_vm.label,"is-small":_vm.isSmall,"loading":_vm.loading,"is-full-screen":_vm.isFullScreen}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }